import { defineMessages } from 'react-intl';

export const scope = 'app.components.ReportCardUnavailable';

// Shown to a parent or link holder whose report card the server withholds; it never says why.
export const messages = defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'This report card isn\'t available.',
  },
  body: {
    id: `${scope}.body`,
    defaultMessage: 'It hasn\'t been shared with you, or access to it has been turned off. Contact the organization if you think this is a mistake.',
  },
});
